import Vue from 'vue';
import ConfirmComponent from './confirm.vue';

let instance;
// confirm 是否存在的标记位
let installed = false;

const ConfirmConstructor = Vue.extend(ConfirmComponent);

const initInstance = () => {
    instance = new ConfirmConstructor({
        el: document.createElement('div'),
    });
    document.body.appendChild(instance.$el);
};

// 显示
const Confirm = (options) => {
    const {
        title,
        content,
        cancelText = '取消',
        confirmText = '确认',
        onClose = () => {},
        onConfirm = () => {},
    } = options;
    // 如果没有实例化，则实例化
    if (!installed) {
        installed = true;
        initInstance();
    }
    instance.show = true;
    instance.title = title;
    instance.content = content;
    instance.cancelText = cancelText;
    instance.confirmText = confirmText;
    instance.onClose = onClose;
    instance.onConfirm = onConfirm;
};

export default {
    install(vue) {
        vue.prototype.$confirmV2 = Confirm;
    },
};
